import { dbg, find, findAll } from "../../functions"

/**
 * Order class to handle the order process in the custom Powermail extension
 */
export default class Order {
    constructor(target, _t, int, coD, orderArray) {
        this.timestamp = Math.floor(Date.now() / 1000)
        this.id = "oo-" + int + this.timestamp
        this.tgt = target ? target : undefined
        this.cPM = _t ? _t : undefined
        this.coDisplay = coD
        this.category = int
        this.article = undefined
        this.count = 1
        this.gender = undefined
        this.omn = undefined
        this.date = undefined
        this.adress = undefined
        this.message = undefined
        this.orderArray = orderArray
        this.previousTarget = null
        this.navButtons = document.querySelector(".powermail_fieldset_8 .powermail_tab_navigation")
        this.startOrder()
        this.cPM.disableContinue()
        this.articles = [
            ["327", "biologisch abbaubare Säcke für 240 Liter Behälter Rolle a 10 Stück"],
            ["311", "Lenkrollen für 1.100 Liter Behälter"],
            ["310", "Bestellung 240 Liter Behälter"],
            ["231", "Großtier untauglich verworfen"],
            ["230", "Kleintier untauglich verworfen - mit Ohrmarkennummer"],
            ["230", "Kleintier untauglich verworfen"],
            ["228", "Eier nach Gewicht"],
            ["222", "Schlachabfälle nach Gewicht in 1.100 Liter Behälter"],
            ["212", "Schlachtabfälle nach Gewicht in 240 Liter-Behälter"],
            ["202", "Schlachtabfälle nach Gewicht in 120 Liter-Behälter"],
            ["054", "sonstiges Haustier"],
            ["053", "Hund"],
            ["051", "Katze"],
            ["013", "Andere Einhufer (Esel, Maultier etc.)"],
            ["012", "Pony"],
            ["011", "Fohlen"],
            ["010", "Pferd"],
            ["091", "Kameliden (Kamel, Lama)"],
            ["080", "Fische"],
            ["077", "Enten nach Gewicht"],
            ["076", "Truthuhn nach Gewicht"],
            ["075", "Huhn nach Gewicht"],
            ["074", "Laufvogel (Strauß, Emu)"],
            ["073", "Wassergeflügel (Gans, Ente)"],
            ["072", "Sonstiges Geflügel"],
            ["066", "Biber"],
            ["065", "Wildklauentier (Gehegewild)"],
            ["064", "Reh"],
            ["063", "Wildschwein"],
            ["061", "Fuchs"],
            ["060", "Hase/Kaninchen"],
            ["059", "Sonstiges Wildtier (Schwan etc.)"],
            ["048", "Ziege über 18 Monate"],
            ["047", "Lämmertonne"],
            ["044", "Ziege 6 bis 18 Monate"],
            ["043", "Kitz bis 6 Monate"],
            ["041", "Schaf 6 bis 18 Monate"],
            ["040", "Lamm bis 6 Monate"],
            ["038", "Schaf über 18 Monate"],
            ["035", "Ferkeltonne"],
            ["037", "Zuchtschwein"],
            ["034", "Eber"],
            ["033", "Mutterschwein"],
            ["032", "Schwein über 30 kg"],
            ["031", "Läufer/Absatzferkel bis 30 kg"],
            ["030", "Saugferkel/Totgeburt bis 5kg"],
            ["029", "Kalb bis 7 Tage (ohne Ohrmarkennummer)"],
            ["028", "Kuh über 48 Monate"],
            ["027", "Bulle über 48 Monate"],
            ["026", "Kuh über 24 bis 48 Monate"],
            ["025", "Bulle über 24 Monate bis 48 Monate"],
            ["024", "Kalbin über 12 bis 24 Monate"],
            ["023", "Mastrind über 12 bis 24 Monate"],
            ["022", "Fresser bis 12 Monate"],
            ["021", "Jungvieh bis 12 Monate"],
            ["020", "Kalb bis 3 Monate"],
            ["019", "Ausländische Kuh über 24 Monate"],
            ["018", "Ausländischer Bulle über 24 Monate"]
        ];
    }

    /**
     * starts the order process by setting up the form and initial values
     * @returns {void}
     */
    startOrder() {
        let p = this.cPM
        let aadressControl = document.querySelector(".powermail_fieldwrap_aadress")
        p.setTextContinueBtn("Weiter")
        p.addButtonArticleAddAndRepeat()
        p.disableContinue()
        this.hideAndShowNavButtons(true)
        this.setAllValues()
        this.clearSingleArticleDisplay()
        p.resetButtonDisplay()
        p.setCheckedButton(this.tgt, this.category)
        p.hideAllArticleControls()
        p.showArticleRadio(this.category)
        p.resetAllArticleInputs()
        if (p.orderArray.length > 0) p.disableSubmit()

        if (aadressControl) {
            p.listenForAdressChange(aadressControl)
        }
    }

    /**
     * sets the article value and shows the selected article
     * @param {HTMLElement} target
     * @returns {void}
     */
    setArticle(target) {
        if (target !== this.previousTarget) {
            if (target) {
                this.article = target.value
            }

            let type = this.cPM.getTypeOfRadio(target) || undefined
            this.cPM.showControlsForSpecificRadio(type)
            this.cPM.articleRadio = target || undefined
            this.coDisplay.refreshDisplay()

            let submit = document.querySelector(this.cPM.FormClassOrID + " input[type='submit']")
            let rmv = document.querySelector(".powermail_fieldwrap_checkout_display .error")
            if (submit) {
                this.cPM.orderStarted = false
                if (rmv) rmv.remove() // remove errors
                if (submit.disabled) submit.disabled = false
            }
            this.singleArticleDisplay(target)
        }
        this.previousTarget = target
    }

    /**
     * displays the selected article in the form
     * @param {HTMLElement} tgt
     */
    singleArticleDisplay(tgt) {
        let p = this.cPM
        if (tgt.value) {
            // hide radios
            p.radioClassAdds.forEach((rb) => {
                let elem = document.querySelector(rb)
                if (elem && !elem.classList.contains(p.hideClass)) {
                    elem.classList.add(p.hideClass)
                }
            })
            // show selected article
            let container = document.querySelector(".art-cont")
            if (container) {
                container.innerHTML = ""
            } else {
                container = document.createElement("div")
                container.setAttribute("class", "art-cont")
            }
            let head = document.createElement("h4")
            head.innerText = "Ausgewählter Artikel"
            let elem = document.createElement("span")
            elem.innerText = tgt.value
            container.appendChild(head)
            container.appendChild(elem)
            let buttons = document.querySelector(".powermail_fieldwrap_article_select")
            if (buttons) buttons.after(container)

            if (p.vStep2) {
                try {
                    p.vStep2.setActiveArticle(tgt, tgt.value)
                } catch (error) {
                    console.error("Error setting active article in vStep2:", error)
                }
            }

            this.hideAndShowNavButtons(false)
        } else {
            console.error("singleArticleDisplay: no target!")
        }
    }

    /**
     * clears the display of the selected article
     */
    clearSingleArticleDisplay() {
        var info = find(".art-cont")
        if (info) {
            info.remove()
        }
    }

    /**
     * tries to finish the order
     * @returns {Order} itself
     * @returns {boolean} false if no customPowermail object is given or no Order started
     */
    tryFinish() {
        // console.log("tryFinish called", this);
        if (this.cPM && this.setAllValues()) {
            this.cPM.enableContinue()
            this.cPM.enableSubmit()
            this.cPM.removeButtonArticleAddAndRepeat()
            this.createDataForFinal()
            this.cPM.activeOrder = null
            this.cPM.orderStarted = false
            this.cPM.resetAllArticleInputs()
            return this
        } else {
            console.error("no customPowermail object given or not found!", this, this.cPM)
            return false
        }
    }

    /**
     * creates the data array for the final order object and returns it
     * @returns {array} data
     */
    createDataForFinal() {
        var data = [
            this.id,
            this.category,
            this.article + " [" + this.articleNumber + "]",
            this.count,
            this.gender,
            this.date,
            this.omn,
            this.message,
            this.adress,
        ]
        this.cPM.addToFinal(data)
    }

    /**
     * sets all values from the form to the order object
     * @returns {boolean}
     */
    setAllValues() {
        let count = document.querySelector("#powermail_field_sfg1")
        let gender = document.querySelector("#powermail_field_sfg2")
        let omnCountry = document.querySelector("#powermail_field_omn_country")
        let omn = document.querySelector("#powermail_field_omn")
        let date = document.querySelector("#powermail_field_sfg3")
        let msg = document.querySelector("#powermail_field_msg")
        let adress = document.querySelectorAll(".powermail_fieldwrap_aadress .radio input")
        let fullOMN = ""

        count ? this.setCount(count.value) : console.error("count not found!")
        gender ? this.setGender(gender.value) : console.error("gender not found")
        date ? this.setDate(date.value) : console.error("date not found")
        msg ? this.setMessage(msg.value) : console.error("message not found")

        // get and set full omn number
        if (omn && omnCountry) {
            fullOMN = omnCountry.value + omn.value
            this.setOmn(fullOMN)
        }

        adress.forEach((adr) => {
            if (adr.checked) {
                this.setAdress(adr.value)
            }
        })

        this.setArticleNumber();

        return true
    }

    setArticleNumber() {
        let articleNumber = 0;
        let ageInMonths;

        if (!this.article) {
            return;
        }

        // compare this.article with string in this.articles and set articleNumber if found
        this.articles.forEach((art) => {
            if (art[1] === this.article) {
                articleNumber = art[0];
                console.log(articleNumber, " found for article: ", this.article);
            }
        });

        if (this.article == "Tier mit Ohrmarkennummer") {
            // get ageInMonths from date
            if (this.date && this.date !== " ") {
                ageInMonths = this.diffInMonths(this.date);
                console.debug("setArticleNumber: ageInMonths calculated as: ", ageInMonths);
                this.setFlags(ageInMonths);
            } else {
                ageInMonths = 0; // Default to 0 if no date is set
                this.flags = [];
            }

            // set articleNumber based on this.flags
            if (this.flags.length > 0) {
                console.log(this.flags, " found for ageInMonths: ", ageInMonths);
                if (this.flags.includes("over_48_months")) {
                    articleNumber = "028"; // Kuh über 48 Monate
                    this.article = "Rind über 48 Monate";
                } else if (this.flags.includes("from_24_to_48_months")) {
                    articleNumber = "026"; // Kuh über 24 bis 48 Monate
                    this.article = "Rind über 24 bis 48 Monate";
                } else if (this.flags.includes("from_12_to_24_months")) {
                    articleNumber = "024"; // Kalbin über 12 bis 24 Monate
                    this.article = "Rind über 12 bis 24 Monate";
                } else if (this.flags.includes("up_to_12_months")) {
                    articleNumber = "022"; // Fresser bis 12 Monate
                    this.article = "Rind bis 12 Monate";
                } else if (this.flags.includes("up_to_3_months")) {
                    articleNumber = "020"; // Kalb bis 3 Monate
                    this.article = "Kalb bis 3 Monate";
                }
            }

            let omnCountry = document.querySelector("#powermail_field_omn_country").value;
            // ausländisches Rind
            if (this.flags.includes("over_24_months") && omnCountry != "DE") {
                articleNumber = "019"; // Ausländische Kuh über 24 Monate
                this.article = "Ausländisches Rind über 24 Monate";
            }
        }

        // console.log("setArticleNumber: article number set to: ", articleNumber);
        this.articleNumber = articleNumber;
    }

    diffInMonths(dateStr) {
        const [day, month, year] = dateStr.split(".");
        const inputDate = new Date(`${year}-${month}-${day}`);
        const today = new Date();

        let years = inputDate.getFullYear() - today.getFullYear();
        let months = inputDate.getMonth() - today.getMonth();
        let totalMonths = years * 12 + months;

        if (inputDate.getDate() < today.getDate()) {
            totalMonths -= 1;
        }

        return Math.abs(totalMonths);
    }

    setFlags(ageInMonths) {
        const dateFlags = ['over_48_months', 'from_24_to_48_months', 'from_12_to_24_months', 'up_to_12_months', 'up_to_3_months', 'over_24_months'];
        let flags = [];
        // Check the age in months and set the flags accordingly
        if (ageInMonths > 48) {
            flags.push(dateFlags[0]); // over_48_months
        } else if (ageInMonths > 24 && ageInMonths <= 48) {
            flags.push(dateFlags[1]); // from_24_to_48_months
            flags.push(dateFlags[5]); // over_24_months
        } else if (ageInMonths > 12 && ageInMonths <= 24) {
            flags.push(dateFlags[2]); // from_12_to_24_months
        } else if (ageInMonths > 3 && ageInMonths <= 12) {
            flags.push(dateFlags[3]); // up_to_12_months
        } else if (ageInMonths <= 3) {
            flags.push(dateFlags[4]); // up_to_3_months
        }
        if (flags.length > 0) {
            this.flags = flags;
        }
        return flags;
    }

    /**
     * hides or shows the navigation buttons
     * @param {boolean} hide - true = hide, false = show
     */
    hideAndShowNavButtons(hide) {
        if (this.navButtons && hide) {
            this.navButtons.classList.contains("hidden") ? undefined : this.navButtons.classList.add("hidden")
        } else if (this.navButtons && !hide) {
            this.navButtons.classList.contains("hidden") ? this.navButtons.classList.remove("hidden") : undefined
        }
    }

    // GETTER & SETTER

    setCount(newCount) {
        this.count = newCount
    }

    setGender(gender) {
        this.gender = gender
    }

    setOmn(omn) {
        this.omn = omn
    }

    setDate(date) {
        this.date = date
        // Convert date to German format if needed
        if (date && date !== " ") {
            let isoDate = date;
            let [year, month, day] = isoDate.split("-");
            this.date = `${day}.${month}.${year}`;
        }
    }

    setAdress(adress) {
        this.adress = adress
    }

    setMessage(message) {
        this.message = message
    }

    getCount() {
        return this.count
    }

    getGender() {
        return this.gender
    }

    getOmn() {
        return this.omn
    }

    getDate() {
        return this.date
    }

    getAdress() {
        return this.adress
    }

    getMessage() {
        return this.message
    }
}
